import React, { useEffect } from "react";
import Heading from "../../heading/heading";
import "./contact.css";
import Card from "./card_contact";
import list from "./list";
import Navbar from "../../navbar/Navbar";
import Footer from "../../footer/footer";
import locationIcon from "./images/location.png";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="main">
        <Heading title="Get In Touch" />

        <div className="map_section">
          <div className="map">
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3846.55027183886!2d28.299522414765526!3d-15.400823817500282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19408b4d7b453da1%3A0x63e6629bafab00ac!2sSibweni%20Rd%2C%20Lusaka%2C%20Zambia!5e0!3m2!1sen!2sru!4v1613267532437!5m2!1sen!2sru"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: "0" }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            ></iframe>
          </div>
          <div className="detail">
            <div className="social_media">
              <div className="contact_details">
                <h1>
                  <img src={locationIcon} alt="" /> Address
                </h1>
                <p>Sibweni Road, Northmead, Lusaka, Zambia. P. O. Box 34808</p>
              </div>
            </div>
            {list.map((item) => (
              <Card
                key={item.id}
                img={item.img}
                title={item.title}
                para={item.para}
                link={item.link}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
